import { DateUtils, TypeUtils } from '@vectord/utils';

import createErrorHandler from 'utils/createErrorHandler';

function validateClassesSchedule(state) {
  const [errors, addError] = createErrorHandler();

  const selectedClasses = Object.values(state.academyTopics).filter(
    (o) => o.selected
  );

  const dateSelectedForAll = selectedClasses.every(
    (cls) => !TypeUtils.isNullOrUndefined(cls.dateOfTopic)
  );

  const futureDateSelectedForAll = selectedClasses.every(
    (cls) => !cls.dateOfTopic || new Date(cls.dateOfTopic) > new Date()
  );

  // Get all class dates on minute level
  const allClassDates = selectedClasses.map((cls) =>
    Math.floor(new Date(cls.dateOfTopic).getTime() / DateUtils.ONE_MINUTE)
  );
  const sameDateSelectedForMultiple =
    allClassDates.length !== new Set(allClassDates).size;

  if (!dateSelectedForAll) {
    addError('classes_schedule', 'Select date for all classes!');
  }

  if (!futureDateSelectedForAll) {
    addError('classes_schedule', 'Past dates selected for few classes!');
  }

  if (sameDateSelectedForMultiple) {
    addError('classes_schedule', 'Same date selected for multiple classes!');
  }

  return errors;
}

export default validateClassesSchedule;
